export default __webpack_public_path__ + "9c89fcb8eb2593d81098a5754711fc6a.svg";